import { FieldType } from '90.quickConnect.Models/enums';
import { FieldDesc } from '90.quickConnect.Models/models';

export const isFocusableField = ({ fieldType }: FieldDesc): boolean =>
  fieldType === FieldType.Digits || fieldType === FieldType.Numeric || fieldType === FieldType.Text;
